import { gql } from 'src/generated/gql';

export const PRESCRIPTION_TASKS_QUERY = gql(`
  query GetAllPrescriptionTasks {
    staff_getAllPrescriptionTasks {
      id
      eventId
      patient {
        id
      }
      status
      createdAt
      rnNote
    }
  }
`);
